import { InnerQueryExpression } from "./InnerQueryExpression";
import { SortingRule } from "./SortingRule";
import { SelectClause } from "./SelectClause";

export class InnerQueryRequest {
    public readonly multiplicityPath: string;
    public readonly selects: SelectClause[];
    public readonly filter?: InnerQueryExpression;
    public readonly sortingRules?: SortingRule[];
    public readonly groupByRules?: InnerQueryExpression[];
    public readonly skip?: number;
    public readonly take?: number;

    public constructor(
        multiplicityPath: string,
        selects: SelectClause[],
        filter?: InnerQueryExpression,
        sortingRules?: SortingRule[],
        groupByRules?: InnerQueryExpression[],
        skip?: number,
        take?: number
    ) {
        this.multiplicityPath = multiplicityPath;
        this.selects = selects;
        this.filter = filter;
        this.sortingRules = sortingRules;
        this.groupByRules = groupByRules;
        this.skip = skip;
        this.take = take;
    }
}
